import StartOrderModalWrapper from './StartOrderModalWrapper.container'

export default StartOrderModalWrapper
